export default function Factbox({ factbox }) {
  return (
    <div className="border-y-[0.1px] md:border-l-[0.1px] md:border-y-0 border-black py-4 md:py-0 my-4  md:my-0 md:pl-8">
      {factbox.type && <p>Type: {factbox.type}</p>}
      {factbox.theme && <p>Tema: {factbox.theme}</p>}
      {factbox.with && <p>Samarbeid: {factbox.with}</p>}
    </div>
  )
}
